import {
  Sprout,
  Gem,
  Scale,
  TrendingUp,
  TrendingDown,
  ShieldCheck,
  Activity,
  CircleDollarSign,
  LineChart,
  Coins,
  Sparkles,
  Receipt,
  Info,
  Zap,
  Briefcase,
  Star,
  Minus,
  type LucideIcon,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  Sprout,
  Gem,
  Scale,
  TrendingUp,
  TrendingDown,
  ShieldCheck,
  Activity,
  CircleDollarSign,
  LineChart,
  Coins,
  Sparkles,
  Receipt,
  Info,
  Zap,
  Briefcase,
  Star,
  Minus,
};

export const CATEGORY_ICON_DEFAULTS: Record<string, string> = {
  Strategy: 'Sparkles',
  Growth: 'Sprout',
  Quality: 'Gem',
  Valuation: 'Scale',
  Dividend: 'Coins',
  Return: 'TrendingUp',
  Correlation: 'Activity',
  Risk: 'ShieldCheck',
  Leverage: 'Activity',
  Yield: 'CircleDollarSign',
  Financials: 'Receipt',
  Forecast: 'LineChart',
  Other: 'Info',
};

export const CATEGORY_COLOR_DEFAULTS: Record<string, string> = {
  Strategy: '#a78bfa',
  Growth: '#10b981',
  Quality: '#06b6d4',
  Valuation: '#3b82f6',
  Dividend: '#f59e0b',
  Return: '#22c55e',
  Correlation: '#a1a1aa',
  Risk: '#ef4444',
  Leverage: '#f97316',
  Yield: '#eab308',
  Financials: '#f97316',
  Forecast: '#8b5cf6',
  Other: '#6b7280',
};

export function getCategoryIcon(iconName: string | null | undefined): LucideIcon | null {
  if (!iconName) return null;
  return ICON_MAP[iconName] ?? null;
}

export function getCategoryIconForCategory(
  category: string,
  dbIconName?: string | null,
): LucideIcon | null {
  return getCategoryIcon(dbIconName) ?? getCategoryIcon(CATEGORY_ICON_DEFAULTS[category]) ?? null;
}

export function getCategoryColor(category: string): string {
  return CATEGORY_COLOR_DEFAULTS[category] ?? '#6b7280';
}
